import { useEffect, useContext } from 'react';
import { MapContext } from '../contexts/MapContext';

/**
 * Hook para resetar estado do mapa ao clicar no botão de reset do Leaflet
 */
export default function useResetOnZoomReset() {
  const {
    setMarker,
    setProperty,
    setSidebarOpen,
    setGeometries,
    setThemeGeometries,
    setActiveLayers,
    setPropertyCodes,
  } = useContext(MapContext);

  useEffect(() => {
    const timeout = setTimeout(() => {
      const resetBtn = document.querySelector('.leaflet-bar.leaflet-control.reset-zoom-button');
      if (!resetBtn) return;
      const handleReset = () => {
        setMarker(null);
        setProperty(null);
        setSidebarOpen(false);
        setGeometries([]);
        setThemeGeometries({});
        setActiveLayers({});
        setPropertyCodes({ cod_car: null, codigo_imo: null, filename: null });
      };
      resetBtn.addEventListener('click', handleReset);
      return () => resetBtn.removeEventListener('click', handleReset);
    }, 500);
    return () => clearTimeout(timeout);
  }, [
    setMarker,
    setProperty,
    setSidebarOpen,
    setGeometries,
    setThemeGeometries,
    setActiveLayers,
    setPropertyCodes,
  ]);
}
